import { clsx } from 'clsx';
import { useTranslations } from 'next-intl';
import { BsApple, BsGooglePlay } from 'react-icons/bs';

interface IBadgeProps {
  href: string;
  icon?: React.ReactNode;
  eyebrow: string;
  label: string;
}

export function StoreBadge({ href, icon, eyebrow, label }: IBadgeProps): React.JSX.Element {
  return (
    <a
      href={href}
      className={clsx(
        'cm-lift inline-flex items-center gap-2 rounded-xl px-3 py-2 max-sm:min-w-0 max-sm:flex-1 sm:gap-3 sm:rounded-2xl sm:px-6 sm:py-3',
        'bg-card text-foreground shadow-md ring-1 ring-foreground/10 hover:bg-muted hover:shadow-lg hover:ring-foreground/20',
      )}
    >
      {icon}
      <span className="flex min-w-0 flex-col items-start text-start leading-tight">
        <span className="max-w-full truncate text-[9px] font-medium uppercase tracking-wider text-muted-foreground sm:text-[10px]">
          {eyebrow}
        </span>
        <span className="max-w-full truncate text-sm font-semibold sm:text-base">{label}</span>
      </span>
    </a>
  );
}

interface IAppStoreBadgeRowProps {
  className?: string;
}

export function AppStoreBadgeRow({ className }: IAppStoreBadgeRowProps): React.JSX.Element {
  const t = useTranslations('footer.cta');
  const iconClass = 'size-5 shrink-0 sm:size-7';
  return (
    <div className={clsx('flex flex-row items-center gap-2 sm:gap-3', className)}>
      <StoreBadge
        href="/ios"
        icon={<BsApple className={iconClass} />}
        eyebrow={t('appStoreEyebrow')}
        label={t('appStoreLabel')}
      />
      <StoreBadge
        href="/android"
        icon={<BsGooglePlay className={iconClass} />}
        eyebrow={t('googlePlayEyebrow')}
        label={t('googlePlayLabel')}
      />
    </div>
  );
}
